import React, {Component} from 'react';
import {Button, Modal, Form, Grid} from 'semantic-ui-react';
import update from 'react-addons-update';
import connect from "react-redux/es/connect/connect";

import {showToast} from "../../actions/ToastAction";
import CategoryDialog from "./CategoryDialog";
import {recipeDialog} from "../../actions/RecipeDialogActions";
import {selectRecipe} from "../../actions/RecipeSelectActions";
import RecipeData from "../../data/RecipeData";

class RecipeDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: {
                name: '',
                id: '',
                is_active: true
            },
            name_error: false,
        };
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleActive = this.handleActive.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.recipe_dialog) {
            this.setState({data: nextProps.recipe_dialog.recipe});
        }
    }

    handleNameChange = (event) => {
        let name = update(this.state, {
            data: {
                name: {
                    $set: event.target.value
                }
            }
        });
        this.setState(name);
        if (event.target.value.trim() === '') {
            this.setState({name_error: true})
        } else {
            this.setState({name_error: false})
        }
    };

    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.data.name === '') {
            this.setState({name_error: true});
        }else {
            this.setState({disabled_button: true});
            let data = this.state.data
            data.min_stock = data.min_stock === '' ? 0:data.min_stock
            if (data.id) {
                RecipeData.update(data, (res) => {
                    if (res.hasOwnProperty('id')) {
                        this.dispatchData(res, 'Receta Actualizada!');
                    }
                    else if (res.hasOwnProperty('error')) {
                        this.props.showToast({message: res.error, type: 'error'});
                        this.setState({disabled_button: false});
                    }
                    else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                        this.setState({disabled_button: false});
                    }
                });
            } else {
                RecipeData.add(data, (res) => {
                    if (res !== null && res.hasOwnProperty('id')) {
                        this.dispatchData(res, 'Receta Agregada!');
                    }else if (res.hasOwnProperty('error')) {
                        this.props.showToast({message: res.error, type: 'error'});
                        this.setState({disabled_button: false});
                    } else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                        this.setState({disabled_button: false});
                    }
                });
            }
        }
    };

    handleClose = () => {
        this.setState({
            name_error: false,
            data: {
                name: '',
                id: '',
                is_active: true
            }
        });
        this.props.recipeDialog({open: false, recipe: {id: null}});
    };

    handleChange = (e, { name, value }) => {
        let data = update(this.state, {
            data: {
                [name]: {$set: value}
            }
        });
        this.setState(data);
        this.setState({name_error:false});
    };

    handleUnitChange = (result) => {
        let unit = update(this.state, {
            data: {
                unit: {$set: result}
            }
        });
        this.setState(unit);
    };

    handleActive = () => {
        let is_active = update(this.state, {
            data: {
                is_active: {
                    $set: !this.state.data.is_active
                }
            }
        });
        this.setState(is_active);
    };

    dispatchData = (recipe, message) => {
        this.setState({disabled_button: false});
        this.props.selectRecipe(recipe);
        this.props.recipeDialog({
            open: false, recipe: {
                id: null,
                name: '',
                is_active: true
            }
        });
        this.props.showToast({message: message, type: 'success'});
    };

    render() {
        return (
            <div>
                <Modal size='tiny' dimmer='inverted' open={this.props.recipe_dialog.open} onClose={this.handleClose}>
                    <Modal.Header>{this.props.recipe_dialog.recipe.id ? 'Actualizar Receta' : 'Nueva Receta'}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Grid stackable>
                                    <Grid.Row columns={1}>
                                        <Grid.Column>
                                            <Form.Input label='Nombre' placeholder='Nombre' value={this.state.data.name}
                                                        onChange={this.handleNameChange} error={this.state.name_error}/>
                                            <Form.Checkbox label='Receta activa' checked={this.state.data.is_active}
                                                           onChange={this.handleActive}/>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                        <Button primary icon='save' labelPosition='left' disabled={this.state.disabled_button}
                                loading={this.state.disabled_button} onClick={this.handleSubmit}
                                content={this.props.recipe_dialog.recipe.id ? 'Actualizar' : 'Guardar'}/>
                    </Modal.Actions>
                </Modal>
                <CategoryDialog />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        recipe_dialog: state.get('recipe_dialog'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showToast(data) {
            dispatch(showToast(data))
        },
        recipeDialog(data) {
            dispatch(recipeDialog(data))
        },
        selectRecipe(data) {
            dispatch(selectRecipe(data))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RecipeDialog);


// WEBPACK FOOTER //
// ./src/components/inventories/RecipeDialog.js